export default __webpack_public_path__ + "static/media/image-work-company-m.06c1feef.webp";